import React from 'react';

export default () => (
  <svg
    className="inline-block fill-current"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <path
      d="M6,18 L3,18 C2.448,18 2,17.552 2,17 C2,16.448 2.448,16 3,16 L6,16 C6.552,16 7,16.448 7,17 C7,17.552 6.552,18 6,18 L6,18 Z M7,14 L2,14 C0.895,14 0,14.895 0,16 L0,18 C0,19.105 0.895,20 2,20 L7,20 C8.105,20 9,19.105 9,18 L9,16 C9,14.895 8.105,14 7,14 L7,14 Z M17,4 L14,4 C13.448,4 13,3.552 13,3 C13,2.448 13.448,2 14,2 L17,2 C17.552,2 18,2.448 18,3 C18,3.552 17.552,4 17,4 L17,4 Z M18,0 L13,0 C11.895,0 11,0.895 11,2 L11,4 C11,5.105 11.895,6 13,6 L18,6 C19.105,6 20,5.105 20,4 L20,2 C20,0.895 19.105,0 18,0 L18,0 Z M18,17 C18,17.552 17.552,18 17,18 L14,18 C13.448,18 13,17.552 13,17 L13,11 C13,10.448 13.448,10 14,10 L17,10 C17.552,10 18,10.448 18,11 L18,17 Z M18,8 L13,8 C11.895,8 11,8.895 11,10 L11,18 C11,19.105 11.895,20 13,20 L18,20 C19.105,20 20,19.105 20,18 L20,10 C20,8.895 19.105,8 18,8 L18,8 Z M7,9 C7,9.552 6.552,10 6,10 L3,10 C2.448,10 2,9.552 2,9 L2,3 C2,2.448 2.448,2 3,2 L6,2 C6.552,2 7,2.448 7,3 L7,9 Z M7,0 L2,0 C0.895,0 0,0.895 0,2 L0,10 C0,11.105 0.895,12 2,12 L7,12 C8.105,12 9,11.105 9,10 L9,2 C9,0.895 8.105,0 7,0 L7,0 Z"
      id="path-1"
    />
  </svg>
);
